import styled from 'styled-components';
import { Div, theme } from 'styles';

export const ChartWrapper = styled(Div)`
  overflow-x: auto;
  padding-bottom: 10px;
`;

export const ChartContainer = styled.div`
  min-width: ${({ $count }) => $count * 100}px;
  width: 100%;
  height: 270px;
`;

export const CustomLegend = styled.div`
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: 10px;
`;

export const LegendItem = styled.span`
  font-size: 14px;
  line-height: 1.5;
  padding-left: 18px;
  position: relative;
  cursor: pointer;

  ${({ $selected }) => $selected && `text-decoration: line-through;`};

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 5.5px;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${(props) => props.$color};
  }
`;

export const StyledTooltipContainer = styled.div`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  background-color: #ffffff;
  color: white;
  padding: 4px 16px;
  border-radius: 4px;
  transition: opacity 0.1s ease;
  z-index: 1000;
  box-shadow: ${theme.shadows.elevation02};
  white-space: nowrap;

  &:after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #ffffff;
    z-index: 1;
  }

  &:before {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-top: 9px solid rgba(0, 0, 0, 0.09);
    z-index: 0;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    height: 24px;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    color: ${theme.colors.supportive};
  }

  .val {
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.normal};
  }
`;
